import React, {useState} from 'react';
import Dropdown from 'react-bootstrap/Dropdown';
import {NavLink, useNavigate} from 'react-router-dom';
import {useEyeconxStore} from '../../store/eyeconxStore';

function Header() {
    const logout = useEyeconxStore((state) => state.logout);
    const user = useEyeconxStore((state) => state.user);
    const navigate = useNavigate();
    const [showMobileMenu, setShowMobileMenu] = useState(false);

    const handleLogout = () => {
        logout();
        navigate("/login");
    };

    const toggleSidebar = () => {
        document.body.classList.toggle('toggle-sidebar');
    };

    const navigateTo = (path) => {
        navigate(path);
        setShowMobileMenu(false);
    };

    // Specific function for profile navigation with user ID
    const navigateToProfile = () => {
        if (user?.ID) {
            navigate(`/profile/${user.ID}`);
        } else {
            // Fallback if user ID is not available
            navigate('/profile');
        }
        setShowMobileMenu(false);
    };

    return (
        <>
            <header className="fixed-top d-flex align-items-center bg-white shadow-sm py-3">
                <div className="container-fluid">
                    <div className="d-flex align-items-center justify-content-between">
                        {/* Left Section - Logo and Toggle */}
                        <div className="d-flex align-items-center">
                            <i
                                className="bi bi-list me-3 fs-4 text-primary"
                                onClick={toggleSidebar}
                                style={{cursor: 'pointer'}}
                            ></i>
                            <a href="/dashboard" className="logo d-flex align-items-center text-decoration-none">
                                <span className="d-none d-lg-block">
                                    <img
                                        src="https://eyeconx.s3.us-east-2.amazonaws.com/3conx/assets/3f6f63b82cf94f13985e104afd45f226.png"
                                        width="120"
                                        alt="EyeconX"
                                        className="img-fluid"
                                    />
                                </span>
                            </a>
                        </div>

                        {/* Navigation Section */}
                        <nav className="d-flex align-items-center">
                            <ul className="d-flex align-items-center list-unstyled mb-0 me-2">
                                {/* Desktop Navigation */}
                                <div className="d-none d-lg-flex align-items-center">
                                    {/* Main Navigation Links */}
                                    <div className="d-flex align-items-center border-end me-3">
                                        <NavLink
                                            to="/dashboard"
                                            className={({isActive}) =>
                                                `btn btn-sm btn-link text-decoration-none d-flex align-items-center px-3 py-2 ${isActive ? 'text-primary border-bottom border-primary' : 'text-dark'}`
                                            }
                                        >
                                            <i className="bi bi-speedometer2 me-2"></i> Dashboard
                                        </NavLink>
                                        <NavLink
                                            to="/clinics"
                                            className={({isActive}) =>
                                                `btn btn-sm btn-link text-decoration-none d-flex align-items-center px-3 py-2 ${isActive ? 'text-primary border-bottom border-primary' : 'text-dark'}`
                                            }
                                        >
                                            <i className="bi bi-hospital me-2"></i> Clinics
                                        </NavLink>
                                        <NavLink
                                            to="/articles"
                                            className={({isActive}) =>
                                                `btn btn-sm btn-link text-decoration-none d-flex align-items-center px-3 py-2 ${isActive ? 'text-primary border-bottom border-primary' : 'text-dark'}`
                                            }
                                        >
                                            <i className="bi bi-file-medical me-2"></i> Articles
                                        </NavLink>
                                        <NavLink
                                            to="/surveys"
                                            className={({isActive}) =>
                                                `btn btn-sm btn-link text-decoration-none d-flex align-items-center px-3 py-2 ${isActive ? 'text-primary border-bottom border-primary' : 'text-dark'}`
                                            }
                                        >
                                            <i className="bi bi-clipboard-data me-2"></i> Surveys
                                        </NavLink>
                                        <NavLink
                                            to="/campaign"
                                            className={({isActive}) =>
                                                `btn btn-sm btn-link text-decoration-none d-flex align-items-center px-3 py-2 ${isActive ? 'text-primary border-bottom border-primary' : 'text-dark'}`
                                            }
                                        >
                                            <i className="bi bi-megaphone me-2"></i> Campaigns
                                        </NavLink>
                                    </div>

                                    {/* Templates Dropdown */}
                                    <Dropdown className="me-3">
                                        <Dropdown.Toggle
                                            variant="outline-light"
                                            id="dropdown-templates"
                                            className="text-dark btn-sm text-decoration-none border-0 d-flex align-items-center"
                                        >
                                            <i className="bi bi-file-earmark me-2"></i> Templates
                                        </Dropdown.Toggle>
                                        <Dropdown.Menu>
                                            <Dropdown.Item onClick={() => navigateTo('/admin-templates')}>
                                                <i className="bi bi-file-earmark-medical me-2"></i> EyeconX Templates
                                            </Dropdown.Item>
                                            <Dropdown.Item onClick={() => navigateTo('/install-templates')}>
                                                <i className="bi bi-cloud-arrow-down me-2"></i> Install Templates
                                            </Dropdown.Item>
                                            <Dropdown.Item onClick={() => navigateTo('/clinic-templates')}>
                                                <i className="bi bi-file-earmark-medical me-2"></i> Clinic Templates
                                            </Dropdown.Item>
                                        </Dropdown.Menu>
                                    </Dropdown>

                                    {/* Admin Dropdown */}
                                    <Dropdown className="me-3">
                                        <Dropdown.Toggle
                                            variant="outline-light"
                                            id="dropdown-admin"
                                            className="text-dark btn-sm text-decoration-none border-0 d-flex align-items-center"
                                        >
                                            <i className="bi bi-gear me-2"></i> Admin
                                        </Dropdown.Toggle>
                                        <Dropdown.Menu>
                                            <Dropdown.Item onClick={() => navigateTo('/recalls')}>
                                                <i className="bi bi-repeat me-2"></i> Manage Recalls
                                            </Dropdown.Item>
                                            <Dropdown.Item onClick={() => navigateTo('/process')}>
                                                <i className="bi bi-list-task me-2"></i> Process
                                            </Dropdown.Item>
                                            <Dropdown.Item onClick={() => navigateTo('/logs')}>
                                                <i className="bi bi-journal-text me-2"></i> Scheduled Logs
                                            </Dropdown.Item>
                                            <Dropdown.Item onClick={() => navigateTo('/adminsmsgateway')}>
                                                <i className="bi bi-chat me-2"></i> SMS Gateway Stats
                                            </Dropdown.Item>
                                        </Dropdown.Menu>
                                    </Dropdown>
                                </div>

                                {/* User Profile Dropdown */}
                                <Dropdown align="end">
                                    <Dropdown.Toggle
                                        variant="light"
                                        id="dropdown-user"
                                        className="d-flex btn-sm  align-items-center border-0 bg-transparent"
                                    >
                                        <span className="d-none d-md-inline text-dark me-2">
                                            {user?.name || "User Name"}
                                        </span>
                                        <i className="bi bi-person-circle fs-5"></i>
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu className="dropdown-menu-end shadow border-0">
                                        <Dropdown.Item onClick={navigateToProfile}
                                                       className="d-flex align-items-center py-2">
                                            <i className="bi bi-person me-2"></i> My Profile
                                        </Dropdown.Item>
                                        <Dropdown.Item href="https://eyeconx.youtrack.cloud/projects" target="_blank" rel="noopener noreferrer" className="d-flex align-items-center py-2">
                                            <i className="bi bi-question-circle me-2"></i> Help & Support
                                        </Dropdown.Item>
                                        <Dropdown.Divider/>
                                        <Dropdown.Item onClick={handleLogout}
                                                       className="d-flex align-items-center py-2">
                                            <i className="bi bi-box-arrow-right me-2"></i> Logout
                                        </Dropdown.Item>
                                    </Dropdown.Menu>
                                </Dropdown>
                            </ul>
                        </nav>
                    </div>
                </div>
            </header>
        </>
    );
}

export default Header;